const types = {
    SAVE_JDECODE: 'INVESTIGATION/SAVE_JDECODE',
    SAVE_PARAMS: 'INVESTIGATION/SAVE_PARAMS',
    SAVE_CREATE_PARAMS: 'INVESTIGATION/SAVE_CREATE_PARAMS',
};

export const saveJdeCode = jdeCode => ({
    type: types.SAVE_JDECODE,
    jdeCode,
});

export const saveParams = params => ({
    type: types.SAVE_PARAMS,
    params,
});

export const saveCreateParams = params => ({
    type: types.SAVE_CREATE_PARAMS,
    params,
});

const initState = {
    jdeCode: '',
    current: '1',
    pagination: {},
    searchParams: {},
    createParams: {},
    feedBack: false,
};

const investigationReducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_JDECODE:
            return {
                ...state,
                jdeCode: actions.jdeCode
            };
        case types.SAVE_PARAMS:
            return {
                ...state,
                ...actions.params,
            };
        case types.SAVE_CREATE_PARAMS:
            return {
                ...state,
                createParams: {
                    ...actions.params,
                },
            };
        default:
            return state;
    }
}

export default investigationReducer;



// WEBPACK FOOTER //
// ./src/actions/investigationActions.js